<template>
  <div class="pageBox">
    <el-row>
      <!-- 左侧图表部分 -->
      <el-col :span="19" class="leftBox">
        <!-- 图表部分 -->
        <div class="echartsBox">
          <div class="status" id="liveData" ref="statusEcharts"></div>
        </div>
      </el-col>
      <!-- 右侧功能部分 -->
      <el-col :span="4" :offset="1" class="rightBox">
        <!-- 实时心率 -->
        <div class="realData">
          <!-- 标题 -->
          <div class="realTitle">
            <!-- <i class="el-icon-date"></i> -->
            <i class="iconfont icon--"></i>
            <span>实时数据</span>
          </div>
          <div class="center">
            <div>
              <p style="font-size: 14px;">设备编号</p>
              <p style="color: black;font-size: 14px;">{{ deviceNo }}</p>
            </div>
            <!-- <div style="font-size: 14px;">
                  <p>绑定信息</p>
                  <p style="color: black;">{{ deviceNo }}</p>
              </div> -->
          </div>
          <!-- 健康概况 -->
          <div class="center">
            <p>健康概况</p>
            <div>
              <span>
                <p>心率</p>
                <b>{{ heart }}bpm</b>
              </span>
            </div>
            <div>
              <span>
                <p>呼吸率</p>
                <b>{{ breathe }}bpm</b>
              </span>
            </div>
            <div>
              <span>
                <p>是否在线</p>
                <b>{{ offLineStatus }}</b>
              </span>
            </div>
            <div>
              <span>
                <p>是否在床</p>
                <b>{{ status }}</b>
              </span>
            </div>
          </div>
          <!-- 异常状态信息 -->
          <div class="list">
            <p>异常状态信息</p>
            <span>
              <p>呼吸状态</p>
              <b>{{ breatheStatus }}</b>
            </span>
            <span>
              <p>心率状态</p>
              <b>{{ heartStatus }}</b>
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div class="historyBox">
        <div class="status" id="historyData" ref="historyEcharts"></div>
      </div>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import util from "@/utils/util.js";
let hischart = null;
export default {
  data() {
    return {
      deviceNo: '',
      heart: '-',
      breathe: '-',
      offLineStatus: '',
      status: '',
      breatheStatus: '正常',
      heartStatus: '正常',
      heartList: [], //实时心率数据
      breathList: [],
      timeList: [],
      myChart: '',
      option: '',
      historyHeartList: [], //历史心率数据
      historyBreathList: [], //历史呼吸数据
      historyTimeList: [],//
      interval: null,
      time2: null,
    }
  },
  created() {
    this.time2 = setInterval(() => {
      this.getOnLine();
    }, 20 * 1000);
  },
  mounted() {
    console.log(this.$route.query);
    this.deviceNo = this.$route.query.deviceNo;
    this.getOnLine();
    this.drawChart();
    this.getHistoryHeartData();
  },
  beforeDestroy() {
    if (this.time2 != null) {
      clearInterval(this.time2);
      this.time2 = null;
    }
  },
  destroyed() {
    if (this.time2 != null) {
      clearInterval(this.time2);
      this.time2 = null;
    }
  },
  methods: {
    getOnLine() {
      this.$postForm(
        "dmc/mattress/getOnlineStatus",
        {
          sn: this.deviceNo
        }).then(res => {
          if (res.code == 200) {
            if (res.result.status == "false") {
              this.offLineStatus = "离线";
              this.heart = "-";
              this.breathe = "-";
              this.status = "-";
              this.goodData = "-";
              this.breatheStatus = "-";
              this.heartStatus = "-";
              this.outStatus = "-";
            } else {
              this.offLineStatus = "在线";
              this.getRealData();
            }
          }
        })
    },
    getDataTimeStr() {
      let now = new Date();
      return now.toTimeString().substr(0, 8);
    },
    getRealData() {
      if (this.deviceNo == null) {
        return;
      }
      this.$postForm(
        "dmc/mattress/RealData",
        {
          sn: this.deviceNo
        }).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.offLineStatus = "在线"
            if (res.result.status == 0) {
              this.heart = res.result.heart;
              this.breathe = res.result.breathe;
              this.status = "在床";
              this.heartList.push(this.heart);
              this.breathList.push(this.breathe);
              this.timeList.push(this.getDataTimeStr());
              this.myChart.setOption(this.option);
              if (res.result.heartStatus == 1) {
                this.heartStatus = "心率过快";
              } else if (res.result.heartStatus == 2) {
                this.heartStatus = "心率过慢";
              }
              if (res.result.breatheStatus == 1) {
                this.breatheStatus = "呼吸过快";
              } else if (res.result.breatheStatus == 2) {
                this.breatheStatus = "呼吸过慢";
              }
            } else if (res.result.status == 1) {
              this.heart = res.result.heart;
              this.breathe = res.result.breathe;
              this.status = "离床";
            } else {
              this.status = "无信号";
            }
            
          }
        })
    },
    getHistoryHeartData() {
      this.$postForm(
        "dmc/mattress/heartReportByDay",
        { sn: this.deviceNo,
          date: util.formatDate.getBeforeDay()
        }).then(res => {
          console.log(res);
          if (res.code == 200) {
            res.result.data4ks.forEach(item => {
              this.historyHeartList.push(item.q1);
            });
            this.getHistoryBreath();
          }
        })
    },
    getHistoryBreath(){
      this.$postForm(
        "dmc/mattress/breathReportByDay",
        { sn: this.deviceNo,
          date: util.formatDate.getBeforeDay()
        }).then(res => {
          console.log(res);
          if (res.code == 200) {
            res.result.data4ks.forEach(item => {
              this.historyBreathList.push(item.q1);
            });
            this.heart = this.historyHeartList[0];
            this.breath = this.historyBreathList[0];
            this.showHistoryChart();
          }
        })
    },
    showHistoryChart() {
      hischart = echarts.init(document.getElementById("historyData"));
      var option = {
        // backgroundColor: ['#081944'], // 全图默认背景
        visualMap: [
          {
            show: false,
            type: 'continuous',
            seriesIndex: 0,
            min: 0,
            max: 150
          },
          {
            show: false,
            type: 'continuous',
            seriesIndex: 1,
            dimension: 0,
            min: 0,
            max: 30
          }
        ],
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        title: [
          {
            top: '2%',
            left: 'left',
            text: '历史心率',
            textStyle: {
              color: 'black'
            }
          },
          {
            top: '50%',
            left: 'left',
            text: '历史呼吸',
            textStyle: {
              color: 'black'
            }
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        xAxis: [
          {
            axisLabel: {
              color: 'black'
            },
            data: this.historyTimeList
          },
          {
            axisLabel: {
              color: 'black'
            },
            data: this.historyTimeList,
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            axisLabel: {
              color: 'black'
            },
            min: 50
          },
          {
            axisLabel: {
              color: 'black'
            },
            gridIndex: 1,
            min: 10
          }
        ],
        grid: [
          {
            bottom: '58%'
          },
          {
            top: '55%'
          }
        ],
        series: [
          {
            type: 'line',
            showSymbol: false,
            data: this.historyHeartList
          },
          {
            type: 'line',
            showSymbol: false,
            data: this.historyBreathList,
            xAxisIndex: 1,
            yAxisIndex: 1
          }
        ]
      };
      hischart.setOption(option);
    },
    drawChart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById("liveData"));
      this.option = {
        // backgroundColor: ['#081944'], // 全图默认背景
        visualMap: [
          {
            show: false,
            type: 'continuous',
            seriesIndex: 0,
            min: 0,
            max: 100
          },
          {
            show: false,
            type: 'continuous',
            seriesIndex: 1,
            dimension: 0,
            min: 0,
            max: this.timeList.length - 1
          }
        ],
        dataZoom: [
          {
            type: "slider",
            show: this.timeList.length > 100,
            xAxisIndex: [0, 1],
            start: 0,
            end: 10000 / this.timeList.length > 100 ? 100 : 10000 / this.timeList.length
          },
        ],
        title: [
          {
            top: '2%',
            left: 'left',
            text: '实时心率',
            textStyle: {
              color: 'black'
            }
          },
          {
            top: '50%',
            left: 'left',
            text: '实时呼吸',
            textStyle: {
              color: 'black'
            }
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        xAxis: [
          {
            axisLabel: {
              color: 'black'
            },
            data: this.timeList
          },
          {
            axisLabel: {
              color: 'black'
            },
            data: this.timeList,
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            axisLabel: {
              color: 'black'
            },
            min: 50
          },
          {
            axisLabel: {
              color: 'black'
            },
            gridIndex: 1,
            min: 10
          }
        ],
        grid: [
          {
            bottom: '58%'
          },
          {
            top: '55%'
          }
        ],
        series: [
          {
            type: 'line',
            showSymbol: false,
            data: this.heartList
          },
          {
            type: 'line',
            showSymbol: false,
            data: this.breathList,
            xAxisIndex: 1,
            yAxisIndex: 1
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(this.option);
    }
  }
}
</script>
<style lang="scss" scoped>
.pageBox {
  width: 100%;
  // height: 100%;
  background: #fff;

  .el-row {
    height: 100%;

    .historyBox {
      height: 450px;
      width: 100%;
      margin-bottom: 30px;
      overflow: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .status {
        height: 450px;
      }
    }

    .leftBox {
      height: 100%;

      .titleBox {
        height: 50px;

        .el-col {
          line-height: 50px;

          .el-button {
            background: #ebc12b;
            border-color: #ebc12b;
          }
        }

        .inof {
          font-size: 24px;
          color: #4f4e4e;

          span {
            margin: 0 5px;
          }
        }
      }

      .echartsBox {
        width: 100%;
        height: 90%;
        overflow: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
          display: none;
        }

        .status {
          height: 500px;
        }

        .heartbeat {
          height: 200px;
        }

        .breathe {
          height: 200px;
          margin-bottom: 10px;
        }
      }
    }

    .rightBox {
      height: 100%;
      padding-right: 20px;
      //   overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        display: none;
      }

      //   日历部分
      .dayBox {
        width: 100%;

        span {
          display: block;
          width: 46px;
          height: 41px;
          background-color: #ebc12b;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 5px;
          border-radius: 5px;

          i {
            font-size: 20px;
            color: #ffffff;
          }
        }
      }

      //  实时心率
      .realData {
        width: 100%;
        border: 1px solid #e1e3e9;
        margin-top: 20px;
        margin-bottom: 10px;
        box-sizing: border-box;

        //   标题
        .realTitle {
          height: 50px;
          background-color: #fafafa;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #e1e3e9;

          .icon-- {
            color: #ee6666;
            font-size: 28px;
            margin-right: 10px;
          }

          span {
            color: #494949;
            font-size: 18px;
          }
        }

        // 健康概况
        .center {
          padding: 10px;
          background-color: #fafafa;
          border-bottom: 1px solid #e1e3e9;

          p {
            color: #3e3e3e;
            font-size: 16px;
          }

          .one {
            display: flex;

            span {
              width: 50%;
              display: flex;
              flex-wrap: nowrap;

              p {
                font-size: 14px;
                margin-right: 10px;
              }

              b {
                font-size: 14px;
              }
            }
          }

          div {
            margin: 7px 0;

            span {
              display: flex;
              flex-wrap: nowrap;

              p {
                font-size: 14px;
                margin-right: 10px;
              }

              b {
                font-size: 14px;
              }
            }
          }
        }

        // 异常状态
        .list {
          padding: 10px;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          p {
            color: #3e3e3e;
            font-size: 16px;
          }

          span {
            display: flex;
            justify-content: space-between;
            flex-wrap: nowrap;
            padding: 10px;
            box-shadow: 0 0 5px #f2f2f2;
            border-radius: 10px;
            box-sizing: border-box;

            p {
              font-size: 14px;
            }

            b {
              font-size: 14px;
            }

            &:nth-child(2) {

              p,
              b {
                color: #3FB212;
              }
            }

            &:nth-child(3) {

              p,
              b {
                color: #e57825;
              }
            }

            &:nth-child(4) {

              p,
              b {
                color: #62b3ff;
              }
            }

            &:nth-child(5) {

              p,
              b {
                color: #3FB212;
              }
            }
          }
        }
      }
    }
  }
}</style>